import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";

const VideoUploader = ({ show, handleClose, categories, refetch }) => {
  const { backendUrl, user } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    description: "",
    uploader: user.Staff_ID,
    videoFile: null,
  });

  const handleUpload = async (formData) => {
    try {
      // Upload video to external API
      const videoForm = new FormData();
      videoForm.append("file", formData.videoFile);

      const uploadRes = await fetch(
        `${backendUrl}/api/invex-knowledgebase/videoUrl`,
        {
          method: "POST",
          body: videoForm,
        }
      );

      if (!uploadRes.ok) {
        throw new Error("Failed to upload video");
      }

      const { url, thumbnail } = await uploadRes.json();

      // Send data to backend
      const payload = {
        title: formData.name,
        category: formData.category,
        description: formData.description,
        uploader_id: formData.uploader,
        url,
        thumbnail,
        // add uploadData.thumbnail if API provides it
      };

      const res = await fetch(`${backendUrl}/api/invex-knowledgebase/videos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error("Failed to save video details");
      }

      const data = await res.json();
      console.log("Video uploaded successfully:", data);
      // clear the form
      setFormData({
        name: "",
        category: "",
        description: "",
        uploader: user.Staff_ID,
        videoFile: null,
      });
      refetch();
      handleClose();
      toast.success("Video uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err.message);
      toast.error("An error occurred during upload.");
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleUpload(formData);
    // handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Video</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="videoName">
                <Form.Label>Video Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="category">
                <Form.Label>Category</Form.Label>
                <CreatableSelect
                  className=""
                  placeholder="Create or select a category"
                  name="category"
                  options={categories.map((el) => ({
                    label: el,
                    value: el,
                  }))}
                  value={{ label: formData.category, value: formData.category }}
                  onChange={({ value }) =>
                    handleChange({ target: { name: "category", value } })
                  }
                  // onBlur={() => formik.setFieldTouched("issueType", true)}
                />
              </Form.Group>
              {/* <Form.Control
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                /> */}
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows={3}
              required
            />
          </Form.Group>

          <Form.Group controlId="videoFile" className="mb-3">
            <Form.Label>Video File</Form.Label>
            <Form.Control
              type="file"
              name="videoFile"
              onChange={handleChange}
              accept="video/*"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Upload
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default VideoUploader;
